import { ActionContext, ActionTree } from 'vuex'
import { ScheduleStateInterface } from 'src/store/schedule/state'
import { StoreInterface } from 'src/store'
import { QueryOptions } from 'apollo-client'
import { apolloProvider } from 'boot/apollo'
import { QUERY_GET_SCHEDULE, QUERY_GET_DATA_BASE_ON_LEVEL } from 'src/lib/queries/schedule'
import { Level, User } from 'able-lib'

const actions: ActionTree<ScheduleStateInterface, StoreInterface> = {
  newSchedule ({ commit }: ActionContext<ScheduleStateInterface, StoreInterface>): void {
    commit('newSchedule')
    commit('lesson/resetLesson', null, { root: true })
  },

  async getSchedules ({ commit, rootState }: ActionContext<ScheduleStateInterface, StoreInterface>): Promise<void> {
    const user: User = rootState.user.user

    const options: QueryOptions = {
      query: QUERY_GET_SCHEDULE,
      variables: {
        userId: user.id
      },
      fetchPolicy: 'network-only'
    }

    const { data } = await apolloProvider.defaultClient.query(options)

    commit('SET_SCHEDULES', data.schedules)
  },

  async populateDataBaseOnLevel ({ commit }: ActionContext<ScheduleStateInterface, StoreInterface>, level: Level) {
    const options: QueryOptions = {
      query: QUERY_GET_DATA_BASE_ON_LEVEL,
      variables: {
        levelId: level.id
      }
    }

    const { data } = await apolloProvider.defaultClient.query(options)

    commit('setSections', data.sections)
    commit('setLessonPlans', data.originalItems)
  },

  updateLessonplan  ({ commit }: ActionContext<ScheduleStateInterface, StoreInterface>, lessonplan: any) {
    commit('updateLessonplan', lessonplan)
  },

  addLessonplan  ({ commit }: ActionContext<ScheduleStateInterface, StoreInterface>, lessonplan: any) {
    commit('addLessonplan', lessonplan)
  }
}

export default actions
